export const API_URL = process.env.REACT_APP_API_BASE_URL
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID
export const CHAT_WEB_SOCKET_URL = process.env.REACT_APP_CHAT_WEB_SOCKET_URL
export const SLACK_CLIENT_ID = process.env.REACT_APP_SLACK_CLIENT_ID
export const PRODUCT_FRUITS_WORKSPACE_CODE = process.env.REACT_APP_PRODUCT_FRUITS_WORKSPACE_CODE
export const IMPORT_ASSETS_TEMPLATE_KEY = process.env.REACT_APP_IMPORT_ASSETS_TEMPLATE_KEY
export const SIEMBAGPT_ENABLED = process.env.REACT_APP_SIEMBAGPT_ENABLED
export const IMPORT_GENPT_URLS_TEMPLATE_KEY = process.env.REACT_APP_IMPORT_GENPT_URLS_TEMPLATE_KEY
export const IMPORT_GENPT_URLS_SIEMBA_TEMPLATE_KEY = process.env.REACT_APP_IMPORT_GENPT_URLS_SIEMBA_TEMPLATE_KEY
export const ENABLE_QUALYS = process.env.REACT_APP_ENABLE_QUALYS
export const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY
export const APP_MODE = process.env.REACT_APP_MODE
export const GITHUB_APP_NAME = process.env.REACT_APP_GITHUB_APP_NAME
/**
 * redirect to specefic routes based on customer profile status
 * @type {{pentest_review: string, pentest_profile: string, profile: string, pentest_team: string, pentest_scope: string, dashboard: string}}
 */
export const SIEMBA_CUSTOMER_STAGES_ROUTES = {
  "profile": "/profile",
  "pentest_profile": "/pentest/profile",
  "pentest_scope": "/pentest/scope",
  "pentest_team": "/pentest/team",
  "pentest_team_overseers": "/pentest/team_overseers",
  "pentest_team_asset_poc": "/pentest/team_asset_poc",
  "pentest_review": "/pentest/review",
  "dashboard": "/app",
}

export const dashboardEnums = {
  PENTEST_OVERVIEW: 'PENTEST_OVERVIEW',
  MY_DASHBOARD: 'MY_DASHBOARD'
}

export const DATE_FORMAT = "MM/DD/YY"
export const EXPANDED_DATE_FORMAT = "MM/DD/YYYY"


export const userTypes = {
  PROVIDER: 'provider',
  CUSTOMER: 'customer',
};

export const BLOCKER_STATUS = {
  OPEN: "open",
  CLOSED: "closed",
  RESOLVED: "resolved",
  REOPENED: "reopened"
}

export const capitalizeFirstLetter = (str) => {
  return str?.charAt(0)?.toUpperCase() + str?.slice(1);
};

export const AssetCriticality = {
  "P1": {
    title: 'Mission Critical',
    description: [
      "Disruption or loss of these assets could cause severe consequences: financial losses, safety hazards, environmental damage, and reputational harm.",
      "Likely holds highly sensitive data (high impact on Confidentiality).",
      "Supports essential business functions (high impact on Integrity).",
      "Vital for overall organizational security and stability (high impact on Availability).",
    ],
    color: 'var(--functional-red-900)'
  },
  "P2": {
    title: 'Business Critical',
    description: [
      "Important for organizational success and stability; not as critical as mission-critical assets.",
      "Their disruption would significantly hinder operations, causing financial losses or reputational damage.",
      "Likely holds moderately sensitive information (moderate to high impact on Confidentiality).",
      "Supports vital business processes (moderate to high impact on Integrity).",
      "Essential for daily operations (moderate to high impact on Availability)."
    ],
    color: 'var(--functional-red-700)'
  },
  "P3": {
    title: 'Significant Impact',
    description: [
      "Important for efficiency; not directly linked to core mission or financial stability.",
      "Disruption could cause inconvenience and delays, impacting productivity, but could be mitigated without major consequences.",
      "Likely holds non-critical information (moderate impact on Confidentiality), supports specific business functions (moderate impact on Integrity).",
      "Essential for smooth workflow (moderate impact on Availability)."
    ],
    color: 'var(--functional-orange)'
  },
  "P4": {
    title: 'Limited Impact',
    description: [
      "Minimal impact on overall operations; easily replaceable or mitigated.",
      "Disruption causes inconvenience without major impacts on productivity or finances.",
      "Likely holds publicly available information (low impact on Confidentiality).",
      "Has limited impact on business processes (low to moderate impact on Integrity).",
      "Noticeable absence but not detrimental (low to moderate impact on Availability)."
    ],
    color: 'var(--functional-yellow)'
  },
  "P5": {
    title: 'Negligible Impact',
    description: [
      "Virtually no impact on the organization; could go unnoticed if lost.",
      "Loss would have no impact on operations or finances.",
      "Contains non-sensitive or publicly available information (low impact on Confidentiality).",
      "No effect on business processes (low impact on Integrity).",
      "Absence would be undetectable (low impact on Availability)."
    ],
    color: 'var(--functional-blue-50)'
  }
};

export const certificateGradeColors = {
  "A+": "#339933",
  "A": "#33CC33",
  "A-": "#66CC66",
  "B": "#FFCC00",
  "C": "#FF9900",
  "D": "#FF6600",
  "E": "#FF3300",
  "F": "#FF0000",
  "T": "#CC0000",
  "M": "#990000"
}

export const getSeverityColor = (score) => {
  if (score >= 9) return "#9A2335";      // critical
  if (score >= 7) return "#CC394F";      // high
  if (score >= 5) return "#FE7754";      // moderate
  if (score >= 3) return "#7B7D7F";      // low
  return "#7B7D7F";                       // minimal
};

export const getSeverityTitle = (score) => {
  if (score >= 9) return "Critical";
  if (score >= 7) return "High";
  if (score >= 5) return "Moderate";
  if (score >= 3) return "Low";
  return "Minimal";
};

export const cipherSuiteColors = {
  "weak": "#E34F0B",
  "insecure": "#9A2335",
  "secure": "#10635F",
  "recommended": "#10635F"
}

export const easmDefaultMessage = 'Your Attack Surface is currently being mapped. Results coming your way soon!'

export const RTIValues = {
  "High_Data_Loss": {
    "name": "High Data Loss",
    "id": "High_Data_Loss",
  },
  "High_Lateral_Movement": {
    "name": "High Lateral Movement",
    "id": "High_Lateral_Movement",
  },
  "Denial_of_Service": {
    "name": "Denial of Service",
    "id": "Denial_of_Service",
  },
  "No_Patch": {
    "name": "Patch Not Available",
    "id": "No_Patch",
  },
  "Privilege_Escalation": {
    "name": "Privilege Escalation",
    "id": "Privilege_Escalation",
  },
  "Unauthenticated_Exploitation": {
    "name": "Unauthenticated Exploitation",
    "id": "Unauthenticated_Exploitation",
  },
  "Remote_Code_Execution": {
    "name": "Remote Code Execution",
    "id": "Remote_Code_Execution",
  },
  "Active_Attacks": {
    "name": "Active Attacks",
    "id": "Active_Attacks",
  },
  "Malware": {
    "name": "Malware",
    "id": "Malware",
  },
  "Zero_Day": {
    "name": "Zero Day",
    "id": "Zero_Day",
  },
  "Exploit_Public": {
    "name": "Exploit Public",
    "id": "Exploit_Public",
  },
  "Predicted_High_Risk": {
    "name": "Predicted High Risk",
    "id": "Predicted_High_Risk",
  },
  "Easy_Exploit": {
    "name": "Easy Exploit",
    "id": "Easy_Exploit",
  },
  "Exploit_Kit": {
    "name": "Exploit Kit",
    "id": "Exploit_Kit",
  },
  "Wormable": {
    "name": "Wormable",
    "id": "Wormable",
  },
  "Solorigate_Sunburst": {
    "name": "Solorigate Sunburst",
    "id": "Solorigate_Sunburst",
  },
  "Ransomware": {
    "name": "Ransomware",
    "id": "Ransomware",
  },
  "Cisa_Known_Exploited_Vulns": {
    "name": "CISA Known Exploited Vulnerability",
    "id": "Cisa_Known_Exploited_Vulns",
  },
}

export const severityDropdownValues = {
  "urgent": {
    "name": "Urgent",
    "id": "urgent",
  },
  "critical": {
    "name": "Critical",
    "id": "critical",
  },
  "serious": {
    "name": "Serious",
    "id": "serious",
  },
  "medium": {
    "name": "Medium",
    "id": "medium",
  },
  "minimum": {
    "name": "Minimum",
    "id": "minimum",
  },
}

export const externalIntegrations = {
  SLACK: 'slack',
  GITHUB: 'github',
  OPENVPN: 'openvpn',
  JIRA: 'jira',
  SERVICENOW: 'servicenow',
  QUALYS: 'qualys',
  OKTA: 'okta'
};

export const githubAccountType = {
  USER: 'User',
  ORGANIZATION: 'Organization'
}

export const assessmentTypeMap = {
  "genpt": "GenPT",
  "genva": "GenVA",
  "ptaas": "PT"
};